export default __webpack_public_path__ + "static/media/Mindwell-Logo.b07ef805.svg";